import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type ErrorState } from './errorTypes';

const initialState: ErrorState = {
  title: '',
  description: '',
  button: '',
  show: false,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    showError: (
      state,
      action: PayloadAction<{
        title: string;
        description: string;
        button: string;
      }>,
    ) => {
      const { title, description, button } = action.payload;
      state.title = title;
      state.description = description;
      state.button = button;
      state.show = true;
    },
    hideError: (state) => {
      state.title = '';
      state.description = '';
      state.button = '';
      state.show = false;
    },
  },
});

export const { showError, hideError } = errorSlice.actions;

export default errorSlice.reducer;
